import { ZAttrViewInfo } from "src/common/attrView";
import { ZAttribute } from "src/types/ZAttribute";
import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zObjectRefTable = z.object({
  editor: z.literal("ObjectRefTable"),
  multiple: z.boolean().optional(),
  labelAtts: zUid.array().nullish(),
  isCreateButtonAvailable: z.boolean().optional(), // показать или нет унопку создать в моделях
  multipleBlockers: zUid.array().optional(),
  useModal: z.boolean().optional(),
});
export type ZObjectRefTable = z.infer<typeof zObjectRefTable>;

export const makeObjectRefTableProps = (
  attrInfo: ZAttribute,
  component: ZObjectRefTable,
  viewInfo: ZAttrViewInfo | undefined,
) => ({
  attrInfo,
  component,
  viewInfo,
});
